import { useTranslation } from 'react-i18next'

import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
import OrganoDestino from 'src/components/views/EscritosLexnet/components/shared/components/OrganoDestino/OrganoDestino'

function Destino(): JSX.Element {
  const { t } = useTranslation()

  return (
    <FieldsetGroup legend={t('form.legend.destino')}>
      <OrganoDestino />
    </FieldsetGroup>
  )
}

export default Destino
